import { render, staticRenderFns } from "./ControleDesmatamentoAmazoniaPontos.vue?vue&type=template&id=089702e4&lang=pug"
import script from "./ControleDesmatamentoAmazoniaPontos.vue?vue&type=script&lang=js"
export * from "./ControleDesmatamentoAmazoniaPontos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports